import React, { useCallback, useState } from 'react'
import { useStyles } from './style'
import { Box, Grid, Typography, IconButton, Chip } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import { NoThumbnailImage } from '../../../components/icons'
import { parseISO } from 'date-fns'
import SkillBitePreviewModal from '../skill-bite-preview-modal'
import { generatePath } from 'react-router'
import { routes } from '../../../routes'
import { Link } from 'react-router-dom'

const SkillBiteItem = ({ skillBite, index }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const getThumbnailImage = () => {
    if (skillBite.image?.imgUrl) {
      return (
        <Box data-test={`skill-bite-thumbnail-${index}`}>
          <img
            alt={skillBite.image?.altText}
            src={skillBite.image.imgUrl}
            className={classes.cardImage}
          />
        </Box>
      )
    }
    return (
      <div className={classes.noImageIconWrapper}>
        <NoThumbnailImage />
      </div>
    )
  }

  const handlePreviewClick = useCallback((evt) => {
    evt.stopPropagation()
    evt.preventDefault()
    setOpen(true)
  }, [])

  return (
    <>
      <Link to={generatePath(routes.skillBiteEdit.path, { skillBiteId: skillBite.id })} style={{ textDecoration: 'none', color: '#000' }}>
        <Grid
          role='row button'
          data-test={`skill-bite-list-item-${index}`}
          container
          tabIndex={0}
          direction='row'
          alignItems='center'
          className={classes.gridRow}
        >
          <Grid item md={4} className={classes.skillBiteTitleColumn}>
            <Box display='flex' alignItems='center'>
              {getThumbnailImage()}
              <Box>
                <Typography
                  variant='body2'
                  data-test={`skill-bite-title-${index}`}
                >
                  {skillBite.name}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={1}>
            <Typography variant='body2'>
              {skillBite.expert ? <WorkspacePremiumIcon color='primary' /> : null}
            </Typography>
          </Grid>
          <Grid item md={1}>
            <Typography variant='body2'>
              {skillBite.sessions.length}
            </Typography>
          </Grid>
          <Grid item md={2}>
            <Typography variant='body2'>
              {parseISO(skillBite.createdAt).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item md={2}>
            <Typography variant='body2'>
              {skillBite.author}
            </Typography>
          </Grid>
          <Grid item md={1}>
            <Typography variant='body2'>
              <Chip
                label={skillBite.published ? 'Published' : 'Draft'}
                color={skillBite.published ? 'success' : 'primary'}
                size='small'
                sx={{ borderRadius: '4px', color: '#FFF', ':hover': { cursor: 'pointer' } }}
              />
            </Typography>
          </Grid>
          <Grid item md={1}>
            <IconButton onClick={handlePreviewClick}>
              <LaunchIcon color='primary' />
            </IconButton>
          </Grid>
        </Grid>
      </Link>
      <SkillBitePreviewModal
        skillBite={skillBite}
        open={open}
        setOpen={setOpen}
      />
    </>
  )
}

export default SkillBiteItem
